// Mobile has no separator settings at this time, so render nothing.
const SeparatorSettings = () => null;
export default SeparatorSettings;
